import React, { useEffect } from "react";
import { tilesData } from "../../constants/content-mgmt-tiles";
import "./content-management.css";
import ManageEditorialField from "./manageEditorialField";
import ManageKnowledgeBox from "./manageKnowledgeBox";
import ManageLiveTiles from "./manageLiveTiles";

const ContentMgmt: React.FC = () => {
  const [showContents, setShowContents] = React.useState(1);

  useEffect(() => {
    
  }, [showContents]);

  return (
    <div className="contentheader content-mgmt-container">
      <div className="content-container">
        <h2 className="">Content Management</h2>

        <div className="manage-content tabs-wrapper">
          {tilesData.map((m: any) => (
            <div
              className={`contentBtnDiv ${showContents == m.id ? "contentBtnDivActive" : ""}`}
              key={m.id}
              onClick={() => setShowContents(m.id)}
            >
              <p className={`contentBtn`}>{m.name}</p>
              <div className="content-border"></div>
            </div>
          ))}
        </div>
        {showContents === 1 && <ManageLiveTiles />}
        {/* {showContents === 2 && <ManageEditorialField />} */}
        {showContents === 3 && <ManageKnowledgeBox />}
      </div>
    </div>
  );
};
export default ContentMgmt;